// extracted by mini-css-extract-plugin
export default {"filterBoxWrapper":"style_filterBoxWrapper__iOPl6","filterBox":"style_filterBox__gpN8d"};